<template>
    <div class="listing-notifications">
        <FadeList class="notification-list-grid">
            <div class="notification-list-item" v-for="item in visibleItems" :key="item.id">
                <NotificationsItemActivity v-if="isActivity" v-bind="item" @dismiss="$emit('dismiss', item)" />
                <NotificationsItem v-else v-bind="item" @dismiss="$emit('dismiss', item)" />
            </div>
        </FadeList>
    </div>
</template>
<script>
    import NotificationsItem from "./NotificationsItem";
    import NotificationsItemActivity from "./NotificationsItemActivity";
    import FadeList from "../util/FadeList.vue";

    export default {
        name: 'NotificationsList',

        components: {
            NotificationsItem,
            NotificationsItemActivity,
            FadeList,
        },

        props: {
            type: {type: String, required: true},
            items: {type: Array, required: true},
            limit: {type: Number, required: true},
        },

        computed: {
            visibleItems() {
                return this.items.slice(0, this.limit);
            },
            isActivity() {
                return this.type === 'comment';
            }
        },
    }
</script>
<style>
    .notification-list-grid {
      display: grid;
      gap: 10px;
    }
</style>
